import { render, staticRenderFns } from "./TambahkanPesananPengiriman.vue?vue&type=template&id=c11d6ffe&scoped=true&"
import script from "./TambahkanPesananPengiriman.vue?vue&type=script&lang=js&"
export * from "./TambahkanPesananPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./TambahkanPesananPengiriman.vue?vue&type=style&index=0&id=c11d6ffe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11d6ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VFlex,VForm,VLayout,VSelect,VSpacer,VSubheader,VTextField,VTextarea})
